import { IFilter } from "src/@redux/procedures/procedureReducer";
import commonDataAccess from "../commonDataAccess";

class locationDataAccess {
  getLocationDropdown = () => {
    return commonDataAccess.getData(
      "location/get/LocationAndSublocationDropdownList",
    );
  };
  getGridViewDropdownByStepId = (stepId: any) => {
    return commonDataAccess.getData(
      "location/get/getGridViewDropdownByStepId",
      { stepId: stepId },
    );
  };
  getAllLocationDropdown = () => {
    return commonDataAccess.getData("location/get/allSelectList");
  };
  getAllItemDropdown = () => {
    return commonDataAccess.getData("location/get/allItem");
  };

  getLocationTree = () => {
    return commonDataAccess.getData("location/get/getLocationTree");
  };

  getLocationTreeDropdown = () => {
    return commonDataAccess.getData("location/get/getLocationTree-dropdown");
  };
  getAssociatedProcedures = (locationId: number) => {
    return commonDataAccess.getData("location/get/getAssociatedProcedures", {
      locationId,
    });
  };
  getLocationBasicInfo = (locationId: number) => {
    console.log(locationId, "as");
    return commonDataAccess.getData("location/get/locationBasicInfo", {
      locationId,
    });
  };
  saveLocationBasicInfo = (payload: any) => {
    console.log(payload);
    return commonDataAccess.postData(
      "location/save/locationBasicInfo",
      payload,
    );
  };
  deleteLocations = (ids: any) => {
    return commonDataAccess.deleteData("location/delete", { ids: ids });
  };
  getLocationDates = (locationId: number) => {
    return commonDataAccess.getData("location/get/locationDates", {
      locationId,
    });
  };
  saveLocationDates = (payload: any) => {
    return commonDataAccess.postData("location/save/locationDates", payload);
  };
  getLocationSupplier = (locationId: number) => {
    return commonDataAccess.getData("location/get/locationSupplier", {
      locationId,
    });
  };
  saveLocationSupplier = (payload: any) => {
    return commonDataAccess.postData("location/save/locationSupplier", payload);
  };
  getLocationComments = (locationId: number) => {
    return commonDataAccess.getData("location/get/locationComments", {
      locationId,
    });
  };
  saveLocationComments = (payload: any) => {
    return commonDataAccess.postData("location/save/locationComments", payload);
  };
  saveLocationDocuments = (payload: any) => {
    return commonDataAccess.postData(
      "location/save/locationDocuments",
      payload,
    );
  };
  copyLocation = (id: number) => {
    return commonDataAccess.getData(`location/copy`, {
      id: id,
    });
  };
  printLocationReport = (
    organizationId: number,
    reportType: "pdf" | "excel",
  ) => {
    return commonDataAccess.downloadFile(
      `LocationReport/printLocationReport/${organizationId}/${reportType}`,
      {},
      "Legacy",
    );
  };
  getLocationDocumentList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return commonDataAccess.getData("location/get/documents", parameters);
  };

  getOverdueDateList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    return commonDataAccess.getData("location/get/overdueDates", {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    });
  };
  getLocationItemsDropdown = () => {
    return commonDataAccess.getData("location/get/locationItemsDropdown");
  };
  getMaintenanceSchedule = () => {
    return commonDataAccess.getData("location/get/maintenanceSchedule");
  };

  getMaintenanceItemTypes = () => {
    return commonDataAccess.getData("location/get/maintenanceItemTypes");
  };
}

export default new locationDataAccess();
